type Entry = { level: 'info' | 'warn' | 'error'; namespace: string; message: string; timestamp: string; metadata?: Record<string, unknown> };
const endpoint = '/api/client-logs';
const queue: Entry[] = [];
let timer: number | undefined;
let sending = false;

function safe(value: unknown, depth = 0): unknown {
  if (depth > 3) return '[truncated]';
  if (value instanceof Error) return { name: value.name, message: value.message, stack: value.stack };
  if (!value || typeof value !== 'object') return typeof value === 'string' ? value.slice(0, 4096) : value;
  return Object.fromEntries(Object.entries(value as Record<string, unknown>).slice(0, 30).map(([key, item]) => [
    key,
    /token|authorization|cookie|password|secret/i.test(key) ? '[redacted]' : safe(item, depth + 1),
  ]));
}

async function flush() {
  if (sending || !queue.length) return;
  sending = true;
  const entries = queue.splice(0, 20);
  try {
    const response = await fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ entries }), keepalive: true });
    if (!response.ok && response.status >= 500) queue.unshift(...entries);
  } catch {
    queue.unshift(...entries);
  } finally {
    sending = false;
    if (queue.length) schedule();
  }
}

function schedule() {
  if (timer !== undefined) return;
  timer = window.setTimeout(() => { timer = undefined; void flush(); }, 1000);
}

function write(level: Entry['level'], message: string, metadata?: Record<string, unknown>) {
  queue.push({ level, namespace: 'aioffice-website', message: message.slice(0, 8192), timestamp: new Date().toISOString(), metadata: metadata ? safe(metadata) as Record<string, unknown> : undefined });
  if (queue.length > 50) queue.shift();
  schedule();
}

export function initializeClientLogging() {
  window.addEventListener('error', event => write('error', event.message || 'Uncaught browser error', { error: event.error, filename: event.filename, line: event.lineno }));
  window.addEventListener('unhandledrejection', event => write('error', 'Unhandled promise rejection', { reason: event.reason }));
  window.addEventListener('pagehide', () => {
    if (queue.length) navigator.sendBeacon(endpoint, new Blob([JSON.stringify({ entries: queue.splice(0, 20) })], { type: 'application/json' }));
  });
  write('info', 'frontend logging initialized', { route: location.pathname });
}
